<template>
  <a-modal v-model="showModal" :centered="true" :footer="null" :closable="false" width="570px" class="br12" :style="{ padding: '24px' }">
    <h1 class="fw700 font24 gray900 mb-4">Precise Location</h1>
    <p class="mb-0 gray500 font16" :style="{ height: '150px' }">Get more useful results by sharing your location. Open browser settings and allow access to your location.</p>
    <button class="ml-auto br6 text-white fw700 font14 p1224 d-flex" :style="{ background: getPrimaryColor(), border: 'none' }" @click="hide">Got It</button>
  </a-modal>
</template>

<script>
export default {
  name: "LocationErrorMessage",
  data() {
    return { showModal: false }
  },
  methods: {
    show() {
      this.showModal = true
    },
    hide() {
      this.showModal = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/LocationErrorMessage.vue